import xingyeAvatar1 from './xingye-avatar1.png';
import xingyeAvatar2 from './xingye-avatar2.png';
import xingyeAvatar3 from './xingye-avatar3.png';
import xingyeAvatar4 from './xingye-avatar4.png';
import xingyeAvatar5 from './xingye-avatar5.png';
import xingyeBg from './xingye-bg.png';
import xingyeLogo from './xingye-logo.svg';
import xingyePhone from './xingye-phone.png';

export {
  xingyeLogo,
  xingyeBg,
  xingyePhone,
  xingyeAvatar1,
  xingyeAvatar2,
  xingyeAvatar3,
  xingyeAvatar4,
  xingyeAvatar5,
};
